













































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import LogoutButton from './LogoutButton.vue'

@Component({
    components: {
        LogoutButton,
    },
})
export default class Navbar extends Vue {
    navSignupUrl =
        'https://usermodel-assets.s3.ap-northeast-1.amazonaws.com/musio-english-assets/menu-signup-icon.png'
    navLoginUrl =
        'https://usermodel-assets.s3.ap-northeast-1.amazonaws.com/musio-english-assets/menu-login-icon.png'
    navLogoUrl =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/pc_navbar_logo.png'
    blogUrl = 'https://blog.musioenglish.com'
    navLogoMobileUrl =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/ME_logo.svg'
    timelineUrl = '/timeline'
    supportUrl = '/support'
    drawer = false
    contents = [
        { title: 'login', url: '/login' },
        { title: 'join', url: '/plan' },
        { title: 'timeline', url: '/timeline' },
        { title: 'blog', url: this.blogUrl },
    ]

    // not mypage navbar
    showNormalNavbar = true

    jumpFromMobile(content: any) {
        if (content.title === 'blog') {
            this.goTo(content.url)
        } else {
            this.navigate(content.url)
        }
    }
    navigate(route: string): void {
        if (this.$router.currentRoute.path !== route) {
            this.$router.push({ path: route })
        }
    }
    goTo(url: string): void {
        window.open(url, '_blank')
    }
    scrollMove(to: string) {
        // 他のページからホームアイコンをクリックした場合
        if (to == '/' && this.$router.currentRoute.path !== '/') {
            this.navigate(to)
        } else {
            if (to == '/') {
                this.$vuetify.goTo(0)
            } else {
                this.$vuetify.goTo(to)
            }
        }
    }

    get menuShow() {
        return (
            this.$route.path === '/' ||
            this.$route.path.includes('/campaign') ||
            this.$route.path.includes('/plan') ||
            this.$route.path.includes('/timeline')
        )
    }

    get isSlashPlan() {
        return this.$route.path.includes('/plan')
    }

    get isSlashTimeline() {
        return this.$route.path.includes('/timeline')
    }

    get showHomeMenu() {
        return (
            this.$route.path.includes('/campaign') ||
            this.$route.path.includes('/plan') ||
            this.$route.path.includes('/timeline')
        )
    }

    // page loaded
    created(): void {
        // pages which mypage related
        this.showNormalNavbar = this.$route.meta?.requiresAuth != true
    }

    // watch page move
    @Watch('$route')
    onRouteChangeReceived(val: any) {
        // pages which mypage related
        this.showNormalNavbar = val.meta?.requiresAuth != true
    }
}
